import React from 'react';
import { useOrganizationClientRecords } from '../../../../../../../hooks/api/useOrganizationClientRecords';
import ClientRecordsTable from './ClientRecordsTable';
import { SideDrawerContainer } from '../../../../../../v2BaseComponents/SideDrawer';
import MainContentContainer from '../../../../../../v2BaseComponents/MainContentContainer';

export type AdminProfilesRootOwnProps = {};

export type AdminProfilesRootProps = AdminProfilesRootOwnProps;

const AdminProfilesRoot: React.FC<AdminProfilesRootProps> = (_props) => {
    const { isFetchingClientRecords, clientRecords } = useOrganizationClientRecords({});
    return (
        <SideDrawerContainer>
            <MainContentContainer flex={1}>
                <ClientRecordsTable clientRecords={clientRecords} isFetchingClientRecords={isFetchingClientRecords} />
            </MainContentContainer>
        </SideDrawerContainer>
    );
};

export default React.memo(AdminProfilesRoot);
